module.exports = __webpack_public_path__ + "img/ductless_1.270eaab7.png";